import { Confirmation } from 'primeng/api';

// export const DOMAIN_URL = "https://unreefed-hildegarde-babblingly.ngrok-free.app/api/kavach"

// export const DOMAIN_URL = "https://6240132e0cc9.ngrok-free.app/api/kavach"

export const START_STREAM_ID = '1768559958198-0';

export const API_MAPPING = {
    GET_STATION_DEATILS: 'get_stations_details',
    DELETE_STATION_DEATILS: 'delete_station_details',
    ADD_RFID_FILE: 'rfid_placement',
    CREATE_DRAFT_VERSION: 'create_draft_version',
    GET_EACH_STATION_DATA: 'get_each_station_data',
    GET_SURVEY_DATA: 'get_survey_data_excel',
    UPDATE_RFID_PLACEMENT: 'update_rfid_placement',
    GET_STATION_VERSION_FILE: 'get_station_version_file',
    GET_PREVIOUS_VERSION: 'get_current_version',
    BACK_TO_DRAFT: 'back_to_draft',
    // Survey Drafts
    GET_SURVEY_DRAFTS: 'get_survey_drafts',
    GET_SURVEY_DRAFT: 'get_survey_draft',
    DELETE_SURVEY_DRAFT: 'delete_survey_draft',
    FINALIZE_STATION_LAYOUT: 'finalize_station_layout',
    GET_TOC_DOCUMENT_DATA: 'generate_toc',
    GET_OPEN_FILE_STATUS: 'get_station_open_files_status',
    UPDATE_FILE_STATUS: 'update_file_status',
    UPDATE_STATION_AZURE_BLOB: 'update_station_azure_blob',
    HTML_TO_PDF_API: 'htmltoPdf_and_pdftodocx',
    DELETE_STATION_MASTER_DATA:'delete_station_master_data',
    UPDATE_STATUS_COMPLETED:'update_status_completed',
    SEND_TO_ZONE:'sent_to_zone',
    SAVE_RED_GREEN_DATA:'save_red_and_green_data',
    GET_RFID_PLACEMENT_PLAN_PATH: 'get_rfid_tag_placement_plan_excel_path',
    GET_STATION_ASSIGNMENT_STATUS: 'get_station_assignment_status',
    COMPARE_LAYOUT_PDFS: 'compare_layout_pdfs',
    UPLOAD_RFID_DOCUMENTS: 'upload_rfid_documents',
    GENERATE_LAYOUT_PDF: 'generate_layout_pdf'
}

// Form data field name of the generate_layout_pdf API: the gzip file of the layout HTML page
export const LAYOUT_HTML_FIELD = 'layout_html';

// Form data field names of the upload_rfid_documents API
export const RFID_DOCUMENT_FIELDS = {
    STATION_UUID: 'station_uuid',
    VERSION_NUMBER: 'version_no',
    PDF_FILE: 'rfid_pdf_file',
    DXF_FILE: 'rfid_dxf_file',
    COORDINATES_JSON: 'rfid_coordinates_json',
}

// Steps shown in the Submit dialog while the files for verification are made and uploaded, in order
export const RFID_DOCUMENT_STEPS = {
    COORDINATES: 'Reading the asset coordinates',
    DXF: 'Making the DXF file',
    PDF: 'Making the PDF file',
    UPLOAD: 'Uploading the files',
}

// Parts of the PDF step shown in the Submit dialog, in order
export const RFID_PDF_STEP_PARTS = {
    PREPARE: 'preparing the page',
    GENERATE: 'generating the PDF',
}

// Every drawn part of an asset carries this attribute with the value "<asset type>|<asset key>",
// so the asset coordinates can be read from the page
export const ASSET_COORDINATES_ATTRIBUTE = 'data-coords-key';
// Value of the asset coordinates attribute for drawn parts that must not be counted in any asset box.
export const ASSET_COORDINATES_SKIP = 'skip';
// On a turnout line that is drawn as one path, this attribute holds the middle point "x,y" of the line.
// The line is cut there, so each half goes into the box of its own turnout end.
export const ASSET_COORDINATES_SPLIT_AT_ATTRIBUTE = 'data-coords-split-at';

// The two ends of a turnout. Each end gets its own box in the asset coordinates file.
export const CROSSING_ENDS = {
    TRACK_1: 'track1',
    TRACK_2: 'track2',
}

// Number of decimal places a location is rounded to when it is shown or typed in a location input
export const LOCATION_DECIMALS = 3;

// Dependency type that the backend writes in a tag's meta_data_dependencies for the communication point the tag draws
export const COMMUNICATION_POINT_DEPENDENCY_TYPE = 'Communication Point';

// Asset type names used in the asset coordinates file. They are the same as the merged JSON keys
export const ASSET_COORDINATE_TYPES = {
    TRACKS: 'tracks',
    UTILS: 'utils',
    TRAP_POINT: 'Trap Point',
    SIGNAL: 'Signal',
    DEAD_END: 'DEAD END',
    KAVACH_TERRITORY_ENDING_POINT: 'Kavach Territory Ending Point',
    TRACK_TINS: 'Track Tins',
    TABLES: 'tables',
    COMMUNICATION_POINTS: 'Communication Points',
    YMP_DATA: 'ymp_data',
    CROSSING: 'CROSSING',
    DISTANCE_PAIRS: 'Distance Pairs',
}

// Tag group names, the same as the keys in the merged JSON "Tags".
// In the asset coordinates file they are kept inside the "tags" key.
export const TAG_GROUP_NAMES = {
    NORMAL: 'Normal Tags',
    SIGNAL: 'Signal Tags',
    GATE: 'Gate Tags',
    EXIT: 'Exit Tags',
    BORDER: 'Border Tags',
    DEAD_STOP: 'Dead Stop Tags',
    LINE_ADJUSTMENT: 'Line Adjustment Tags',
    ADJUSTMENT: 'Adjustment Tags',
    HIDDEN: 'Hidden Tags',
    TURNOUT: 'Turnout Tags',
} as const;


export const TYPE_OF_TAGS: any = {
    "N": "Normal Tags",
    "S": "Signal Tags",
    "T": "Turnout Tags",
    "X": "Exit Tags",
    "G": "Gate Tags",
    "L": "Line Adjustment Tags",
    "A": "Adjustment Tags",
    "D": "Dead End Tags",
}

export const TAG_DESCRIPTION: any = {
    "N": "Normal Tag",
    "S": "Signal Tag",
    "T": "Turnout Tag",
    "X": "Exit Tag",
    "G": "Gate Tag",
    "L": "Line Adjustment Tag",
    "A": "Adjustment Tag",
    "D": "Dead End Tag",
}

export enum TAGTYPES {
    NORMAL = 'N',
    SIGNAL = 'S',
    TURNOUT = 'T',
    EXIT = 'X',
    GATE = 'G',
    LINE_ADJUSTMENT = 'L',
    ADJUSTMENT = 'A',
    DEAD_END = 'D',
}



// UM 
export const RESOURCE_TYPES = {
    WIDGETS: 'Widgets',
    DASHBOARDS: 'Dashboards',
    APIS: 'APIs'
}


export const USER_ROLES = {
    SUPER_ADMIN: 'Super Administrator'
}

export const ADD_STATION_STATUS = true;

/** Breadcrumb text on the landing page: 'CAD' in export-dwg mode, 'Home' otherwise. */
export const LANDING_BREADCRUMB_LABELS = {
    HOME: 'Home',
    CAD: 'CAD',
};

export const SIGNAL_PLACEMENTS = {
    down: 'below',
    up: "above"
}

export const TAG_MODE_OPTIONS = {
    REGENERATE: 'REGENERATE',
    SPARE: 'SPARE',
    MANUAL: 'MANUAL'
}

export const STATION_FILE_KEYS = {
    tinPdf: "tin_pdf_path",
    tocExcelPdf: "toc_pdf_path",
    tocExcel: "toc_excel_path",
    stationSurvayData: "station_survey_data",
    radioDesignPdf: "radio_design_pdf_path",
    rfigLayout: "rfid_layout_image_path",
    rfidTagData: "rfid_tag_data_pdf_path",
    shuntingLimit: "shunting_limit_filepath",
    mergedTinTagData: "merged_tin_tag_data_path",
    trackProfile: "track_profile_excel_path",
    trackProfilePdfPath: "track_profile_data_pdf_path",
    blockSectionDetails: "block_section_details_filepath",
    previouseVersionmergedTagTinData: "latest_version_merged_tag_tin_data_path",
    redGreenLayoutPath: "red_and_green_data_path",
    tocDataPath: 'toc_tables_json',
    trackProfileDataPath: 'track_profile_tables_json',
    tagDataPath: 'combined_tags_tins_points_json_path',
    tagPlacementPlanDataPath: 'rfid_tag_placement_plan_excel_path',
}

export const STATION_FILE_KEYS_LABELS = {
    tinPdf: "Tin pdf",
    tocExcelPdf: "TOC pdf",
    tocExcel: "TOC excel ",
    stationSurvayData: "station_survey_data",
    radioDesignPdf: "Radio design",
    rfigLayout: "Rfid layout image",
    rfidTagData: "Rfid tag data",
    shuntingLimit: "Shunting limit",
    mergedTinTagData: "Merged tin tag data",
    trackProfile: "Track profile",
    trackProfilePdfPath: "Track profile data",
    blockSectionDetails: "Block section details",
}

export const SIGN_API_ENDPOINTS_LABELS = {
    merged_tin_tag_data_path: "Merged tin tag data",
    toc_excel_path: "TOC excel",
    toc_pdf_path: "TOC pdf",
    track_profile_excel_path: "Track profile",
    track_profile_data_pdf_path: "Track profile",
    tin_pdf_path: "Tins pdf",
    radio_design_pdf_path: "Radio design",
    rfid_tag_data_pdf_path: "Rfid tag data",
}

export const EDIT_INSTRUCTIONS = {
    ADD_TAG: "Add a tag",
    EDIT_TAG: "Edit a tag",
    DELETE_TAG: "Delete a tag",
    TAG_VIEW_UPDATE: "Tag View Update",
    MOVE_TAG: "Move a tag",
    UPDATE_BORDER_TAG: "Updated a border tag",
    CHANGE_RFID: "Change Rfid Number of tag",
    CHANGE_TIN: "Change tin number",
    EDIT_TIN: "Edit tin",
    CHANGE_DIRECTION: "Change Tag Direction",
    CHANGE_TYPE: "Type of a tag",
    SPLIT_TIN: "Split a Tin",
    MERGE_TIN: "Merge a Tin",
    TIN_VIEW_UPDATE: "Tin View Update",
    MOVE_TIN: "Move a Tin",
    COLOR_TIN: "Change Color of a Tin",
    APPROVED: "Approved by user",
    CROSSING_COLOR: "Change Color of a Crossing",
    CROSSING_LOCATION: "Move a Crossing",
    CROSSING_TIN: "Change Tin Number of a Crossing",
    SECTION_POINT: 'Section point',
    SECTION_NAME: 'Section Name',
    TRACK_SECTION_CHANGE: 'Track Section Change',
    LABEL: 'merged_tin_tag_data_json_path',
    EDIT_CENTER_LINE_TEXT: 'edit_center_line_text',
    CHANGE_TABLE_POSITION: 'change_table_positions',
    STYLES_UPDATE: 'styles update',
    TOWER: 'tower',
    SHOW_ADJACENT_SIGNALS: 'SHOW_ADJACENT_SIGNALS',
}

export const SIGN_API_ENDPOINTS = {
    merged_tin_tag_data_path: "",
    toc_excel_path: "ADD_SIGN_TOC",
    toc_pdf_path: "ADD_SIGN_TOC",
    track_profile_excel_path: 'ADD_SIGN_TRACK_PROFILE_DATA',
    track_profile_data_pdf_path: 'ADD_SIGN_TRACK_PROFILE_DATA',
    tin_pdf_path: "ADD_SIGN_TINS_PDF",
    radio_design_pdf_path: "ADD_SIGN_RADIO_PDF",
    rfid_tag_data_pdf_path: "ADD_SIGN_RFID_TAG_DATA",
}

export const TRAPPOINT_DIRECTIONS = {
    left: "left",
    middle: 'middle',
    right: 'right',
}

export const TABLE_MAXMIN_HEIGHT = {
    min: 450,
    max: 600
}


export const ROLES_NAMES = {
    DESIGNER: 'designer',
    VERIFIER: 'verifier',
    APPROVER: 'approver',
    CONSULTANT: 'consultant',
}

export enum WorkflowUserScope {
    SAME = 'same',
    PARENT = 'parent',
    CHILD = 'child'
}

export enum WorkflowHeadings {
    ASSIGN_DRAFT = 'Assign Draft',
    ASSIGN_MAIN_STATION = 'Assign Main Station',
    SELECT_VERIFIER = 'Select Verifier',
    SELECT_APPROVER = 'Select Approver',
    SELECT_CONSULTANT = 'Select Consultant',
    RETURN_TO_DESIGNER = 'Return to Designer',
    RETURN_TO_VERIFIER = 'Return to Verifier',
    RETURN_TO_APPROVER = 'Return to Approver'
}

export const STATION_STATUSES = {
    COMPLETED: 'Completed',
    COMPLETED_STAGE: 'Completed Stage',
    TO_DO: 'To-Do',
    TO_DO_ALT: 'To Do',
    CHANGES_REQUESTED_BY_VERIFIER: 'Changes Requested by Verifier',
    CHANGES_REQUESTED_BY_APPROVER: 'Changes Requested by Approver',
    CHANGES_REQUESTED_BY_CONSULTANT: 'Changes Requested by Consultant',
    IN_VERIFICATION_STAGE: 'In-Verification Stage',
    IN_APPROVAL_STAGE: 'In-Approval Stage',
    IN_CONSULTANT_STAGE: 'In-Consultant Stage'
}

export const STATION_BUILDING_ZONE_IMAGES = {
    "Central Railway": "hbl_station_building_image",
    "Western Railway": "sanad_station_building_image",
    "Eastern Railway": "default_image",
    "East Central Railway": "default_image",
    "East Coast Railway": "default_image",
    "Northern Railway": "default_image",
    "North Central Railway": "default_image",
    "North Eastern Railway": "default_image",
    "Northeast Frontier Railway": "default_image",
    "North Western Railway": "default_image",
    "Southern Railway": "default_image",
    "South Western Railway": "default_image",
    "South Central Railway": "default_image",
    "South East Central Railway": "default_image",
    "South Eastern Railway": "default_image",
    "West Central Railway": "default_image"
}

export const YMP_POINT_SIZES_Y = {
    "dead_ends": 24,
    "turnout_points": 45,
    "trap_points": 45,
    // "turnouts":24,
    "signal": 24
}

export const YMP_POINT_SIZES_X = {
    "dead_ends": 3,
    "turnout_points": 6,
    "trap_points": 6,
    // "turnouts":24,
    "signal": 3
}

export const YMP_TYPES = {
    DEAD_ENDS: 'dead_ends',
    TURNOUT_POINTS: 'turnout_points',
    TRAP_POINTS: 'trap_points',
    SIGNAL: 'signal',
    TAGS: 'tags'
} as const;

export type YmpType = typeof YMP_TYPES[keyof typeof YMP_TYPES];

export const SSE_STATUS = {
    PROCESSING_COMPLETED: 'Processing Completed'
};

export const svgNS = "http://www.w3.org/2000/svg";

export enum Tabs {
    RFID_Tag_Layout = 'RFID Tag Layout',
    TOC = 'TOC',
    Track_Profile_Data = 'Track Profile Data',
    Tag_Data = 'Tag Data',
    Generate_SLF_And_CTF = 'Generate SLF & CTF',
    Tag_Persistence_Table = 'Tag Placement Plan',
    VersionChanges =  'Version Changes',
}


export enum Tin {
    START = 'start',
    END = 'end'
}

export const SIGNAL_TELECOM_LABLES: { [key: string]: string } = {
    zone: 'Zone',
    division: 'Division',
    section: 'Section',
    station_name: 'Station Name',
    station_code: 'Station Code',
    station_id: 'Station Id',
    ref_sip_no: 'Ref. SIP No.',
    ref_control_table_no: 'Ref. Control Table No.',
    ref_rfid_tag_layout_no: 'Ref. RFID Tag Layout No.',
  };

export enum Assets {
    SIGNAL = 'Signal',
    TAGS = 'Tags',
    DEADEND = 'Deadend',
    DEAD_END = 'Dead End',
    TRACK_CIRCUITS = 'TrackCircuits',
    TRACK_SECTIONS = 'TrackSections',
    TRAP_POINT = 'TrapPoint',
    YMP = 'Ymp',
    TUNNEL = 'Tunnel',
    FMP = 'Fmp',
}

export const tagColorOptions = [
    { label: 'Red', value: '#ff0000' },
    { label: 'Black', value: '#000000' },
    { label: 'Green', value: '#1e951e' },
    { label: 'Yellow', value: '#ffff00' }
];

export const distancePairDirectionOptions = [
    { label: 'Up', value: 'up' },
    { label: 'Down', value: 'down' }
];

export const LOCK_REFRESH_INTERVAL = 180000

// Key of the confirm dialog that shows UNSAVED_CHANGES_CONFIRMATION
export const UNSAVED_CHANGES_DIALOG_KEY = 'unsavedChanges';

// Generic alert for leaving a screen or step that has unsaved changes.
export const UNSAVED_CHANGES_CONFIRMATION: Confirmation = {
    key: UNSAVED_CHANGES_DIALOG_KEY,
    header: 'Unsaved Changes',
    message: 'You have unsaved changes. If you continue without saving, your changes will be lost. Do you want to proceed?',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Continue without Saving',
    rejectLabel: 'Cancel',
    acceptButtonStyleClass: 'p-button-danger',
    rejectButtonStyleClass: 'p-button-text'
};

export enum CommentStatus {
    OPEN = 'Open',
    RESOLVED = 'Resolved'
}
